export function applyTimeAndSeason(now = new Date()) {
  const h = now.getHours();
  const m = now.getMonth();
  let time: 'day' | 'dusk' | 'night' = 'day';
  if (h >= 19 && h < 21) time = 'dusk';
  else if (h >= 21 || h < 6) time = 'night';
  document.documentElement.dataset.time = time;
  let season: 'winter' | 'spring' | 'summer' | 'autumn' = 'summer';
  if ([11, 0, 1].includes(m)) season = 'winter';
  else if ([2, 3, 4].includes(m)) season = 'spring';
  else if ([8, 9, 10].includes(m)) season = 'autumn';
  document.documentElement.dataset.season = season;
}

export function setTheme(t: 'light' | 'dark' | 'auto') {
  const root = document.documentElement;
  if (t === 'auto') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', t);
  try { localStorage.setItem('lafete:theme', t); } catch {}
}

export function loadTheme() {
  try {
    const t = localStorage.getItem('lafete:theme') as 'light' | 'dark' | 'auto' | null;
    if (t) setTheme(t);
  } catch {}
}

export function getStoredTheme(): 'light' | 'dark' | 'auto' {
  try {
    const t = localStorage.getItem('lafete:theme') as 'light' | 'dark' | 'auto' | null;
    return t ?? 'auto';
  } catch { return 'auto'; }
}

export const applyTheme = setTheme;
